import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import Preview from "./Preview";
import BannerImages from "../../Common/BannerImages";
import { useSelector } from "react-redux";

export function ShopSelection({ selectedRow }: any) {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);

    const bannierImagePath = React.useMemo(
        () => ["Application", "ChoixBoutique", "Default", "BannierBoutique"],
        []
    );

    const logoImagePath = React.useMemo(
        () => ["Application", "ChoixBoutique", "Default", "LogoBoutique"],
        []
    );

    const tabs = [
        {
            title: t("Shop selection"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={bannierImagePath}
                                title="Image de la banniere"
                                size="(png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={logoImagePath}
                                title="Logo"
                                size="30*30 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "65% " }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => {
                            return (
                                <NavItem
                                    key={index}
                                    className={classNames(
                                        "pb-1",
                                        "d-flex align-items-center text-nowrap",
                                        {
                                            "disable-nav-item__clz":
                                                activeTab !== index,
                                        },
                                        element.customClassName
                                    )}
                                    style={{
                                        cursor: "pointer",
                                        borderBottom:
                                            activeTab === index
                                                ? `${mainColor} 3px solid`
                                                : "",
                                    }}
                                >
                                    <NavLink
                                        className={classNames(
                                            "text-dark w-100",
                                            {
                                                "active customer-account-menu-nav-link-active__clz":
                                                    activeTab === index,
                                                "customer-account-menu-nav-link-disable__clz":
                                                    activeTab !== index,
                                            }
                                        )}
                                        onClick={() => toggleNav(index)}
                                    >
                                        <span
                                            className="px-2"
                                            style={{
                                                font:
                                                    "normal normal 600 20px/27px Segoe UI",
                                            }}
                                        >
                                            {element.title}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            );
                        })}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => {
                        return (
                            <TabPane
                                tabId={index}
                                key={index}
                                style={{ height: "90%" }}
                            >
                                {element.content}
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
            <div style={{ width: "35%" }}>
                <Preview
                    shopData={{
                        shopName: selectedRow[0].subRows[0].Boutique,
                        shopAdress: selectedRow[0].subRows[0].Adresse,
                    }}
                />
            </div>
        </div>
    );
}
